var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('link-group',{attrs:{"settings":_vm.knowMoreSettings,"i18n":_vm.$root.$i18n},on:{"link-group-click":_vm.openLinkGroupItem},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }